import axios from 'axios';
import * as types from '@/store/types';
import Vue from "vue";

const retry = (fn, delay = 1000) => new Promise((resolve) => {
  fn()
    .then(resolve)
    .catch((error) => {
      setTimeout(() => {
        retry(fn, delay).then(resolve);
      }, delay);
    });
});

export default {
  async sendEmailConfirm({ dispatch, commit }, email) {
    const { data } = await axios.post(
      '/api/web/auth/send-email-code',
      {
        email
      }
    );

    return data;
  },
  async verifyEmailCode({ dispatch, commit }, params) {
    const { data } = await axios.post(
      '/api/web/auth/verify-email-code',
      params
    );

    return data;
  },
  async registerFailed({ dispatch, commit }, params) {
    try {
      commit(types.TOGGLE_LOADING);

      const ipData = await axios.get('https://ipapi.co/json/');
      const {city, country_name} = ipData.data;
      const geolocation = city + ', ' + country_name;
      params.geolocation = geolocation;
      const { data } = await axios.post(
        '/api/web/auth/register-failed-user',
        params
      );

      await new Promise((resolve, reject) => {
        ConnectyCube.createSession((error, session) => {
          if (error) {
            reject(error);
          }

          resolve(session);
        });
      });

      const user = await new Promise((resolve, reject) => {
        ConnectyCube.users.signup({
          login: params.username.toLowerCase(),
          email: params.email,
          password: params.email,
          full_name: `${params.first_name} ${params.last_name}`,
        }, (error, user) => {
          if (error) {
            Vue.rollbar.error('Error creating connectyCube user', {
              login: params.username.toLowerCase(),
              email: params.email,
              error
            });

            reject(error);
          }

          Vue.rollbar.debug('ConnectyCube user created', {
            user
          });
          resolve(user);
        });
      });

      await dispatch('updateChatId', {
        id: data.data.profile.user_id,
        chat_id: user.id,
      });

      return true;
    } catch (e) {
      const { error } = e.response ? e.response.data : e;

      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },

  async changeRegisterState({ commit }, params) {
    try {
      commit(types.TOGGLE_LOADING);

      const { res } = await axios.post(
        '/api/web/auth/change-register-state',
        params
      );
      return true;
    } catch (e) {
      const { error } = e.response.data;

      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },

  async verificateToken({ commit }, params) {
    try {
      commit(types.TOGGLE_LOADING);

      const { data } = await axios.post('/api/web/auth/retrieve-state', params);
      return data;
    } catch (e) {
      const { error } = e.response.data;

      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },


  async registerBannedUser({ dispatch, commit }, params) {
    try {
      commit(types.TOGGLE_LOADING);

      const ipData = await axios.get('https://ipapi.co/json/');
      const {city, country_name} = ipData.data;
      const geolocation = city + ', ' + country_name;
      params.geolocation = geolocation;
      const { data } = await axios.post('/api/web/auth/register-banned-user', params);

      await new Promise((resolve, reject) => {
        ConnectyCube.createSession((error, session) => {
          if (error) {
            reject(error);
          }
          resolve(session);
        });
      });

      const user = await new Promise((resolve, reject) => {
        ConnectyCube.users.signup({
          login: params.username.toLowerCase(),
          email: params.email,
          password: params.email,
          full_name: `${data.profile.first_name} ${data.profile.last_name}`,
        }, (error, user) => {
          if (error) {
            Vue.rollbar.error('Error creating connectyCube user', {
              login: params.username.toLowerCase(),
              email: params.email,
              error
            });

            reject(error);
          }

          Vue.rollbar.debug('ConnectyCube user created', {
            user
          });
          resolve(user);
        });
      });

      await dispatch('updateChatId', {
        id: data.id,
        chat_id: user.id,
      });

      return true;
    } catch (e) {
      e.response.data;
      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },


  async register({ dispatch, commit }, params) {

    try {
      commit(types.TOGGLE_LOADING);

      const ipData = await axios.get('https://ipapi.co/json/');
      const {city, country_name} = ipData.data;
      const geolocation = city + ', ' + country_name;
      params.geolocation = geolocation;
      const { data } = await axios.post('/api/web/auth/register', params);

      await new Promise((resolve, reject) => {
        ConnectyCube.createSession((error, session) => {
          if (error) {
            reject(error);
          }
          resolve(session);
        });
      });

      const user = await new Promise((resolve, reject) => {
        ConnectyCube.users.signup({
          login: params.username.toLowerCase(),
          email: params.email,
          password: params.email,
          full_name: `${data.profile.first_name} ${data.profile.last_name}`,
        }, (error, user) => {
          if (error) {
            Vue.rollbar.error('Error creating connectyCube user', {
              login: params.username.toLowerCase(),
              email: params.email,
              error
            });

            reject(error);
          }

          Vue.rollbar.debug('ConnectyCube user created', {
            user
          });

          resolve(user);
        });
      });

      await dispatch('updateChatId', {
        id: data.id,
        chat_id: user.id,
      });

      return true;
    } catch (error) {
      Vue.rollbar.debug('Error creating new user', {
        error
      });

      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },

  async updateChatId(_, params) {
    try {
      await axios.patch(`/api/web/user/${params.id}/chat-id`, params);
      return true;
    } catch (e) {
      return false;
    }
  },

  async updateUser({ commit }, params) {
    try {
      commit(types.TOGGLE_LOADING);

      if (params.email) {
        try {
          await new Promise((resolve, reject) => {
            ConnectyCube.users.update({
              login: params.username,
              email: params.email,
              full_name: `${params.first_name} ${params.last_name}`,
            }, (error, user) => {
              if (error) {
                reject(error);
              }
              resolve(user);
            });
          });
        } catch (error) {
          if (this.locale === "en") {
            this.$swal.fire(
              "Try again later.",
              '',
              "error"
            );
          } else {
            this.$swal.fire(
              "Intenta de nuevo más tarde.",
              '',
              "error"
            );
          }
          return;
        }
      }

      await axios.put(`/api/web/user/${params.id}`, params);

      return true;
    } catch (e) {
      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },

  async updateRevision({ commit }, from) {
    await axios.put(`/api/web/user/revision`, {
      from
    });
  },

  async savePhotos({ commit }, form) {
    try {
      commit(types.TOGGLE_LOADING);
      const { data } = await axios.post(
        `/api/web/user/${form.id}/pictures`,
        form
      );
      return true;
    } catch (e) {
      const { error } = e.response.data;

      return false;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },

  saveToken({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },

  async fetchUser({ commit, dispatch, getters, state }, forceRefresh = false) {
    const currentIsFetched = getters.isFetched && !forceRefresh;

    if (currentIsFetched) {
      return state.user;
    }

    try {
      const { data } = await axios.get('/api/web/auth/me');
      commit(types.FETCH_USER_SUCCESS, { user: data });

      if (!currentIsFetched) {
        dispatch('loginChatUser');
        await dispatch('locale/setLocale', data.profile.language_id === 1 ? 'en' : 'es', { root: true });
      }

      return data;
    } catch (e) {
      commit(types.FETCH_USER_FAILURE);
      return null;
    }
  },

  async login({ commit, dispatch }, credentials) {
    try {
      commit(types.TOGGLE_LOADING);
      credentials.platform = "WEB";
      const { data } = await axios.post('/api/web/auth/login', credentials);

      await dispatch('saveToken', {
        token: data.token,
        remember: credentials.remember
      });

      await dispatch('fetchUser', true);

      return true;
    } catch (e) {
      const { data } = e.response;
      return data.message;
    } finally {
      commit(types.TOGGLE_LOADING);
    }
  },

  async loginChatUser({ commit, state }) {
    await retry(async () => {
      await new Promise((resolve, reject) => {
        ConnectyCube.createSession((error, session) => {
          if (error) {
            reject(error);
          }
          resolve(session);
        });
      });

      await new Promise((resolve, reject) => {
        ConnectyCube.login({
          login: state.user.username,
          password: state.user.email,
        }, (error) => {
          if (error) {
            reject(error);
          }
          resolve();
        });
      });

      await new Promise((resolve, reject) => {
        ConnectyCube.chat.connect({
          userId: state.user.chat_id,
          password: state.user.email,
        }, (error) => {
          if (error) {
            reject(error);
          }
          resolve();
        });
      });

      commit(types.UPDATE_CHAT, true);
    });
  },

  async forgot({ dispatch }, email) {
    try {
      await axios.post('/api/auth/password/email', email);

      return true;
    } catch (e) {
      throw e;
    }
  },

  async reset({ dispatch }, credentials) {
    try {
      await axios.post('/api/auth/password/reset', credentials);

      return true;
    } catch (e) {
      throw e;
    }
  },

  async logout({ commit }, params) {
    try {
      await axios.post('/api/web/auth/logout', params);
      await new Promise((resolve, reject) => {
        ConnectyCube.logout((error) => {
          if (error) {
            reject(error);
          }
          ConnectyCube.chat.disconnect();
          resolve();
        });
      });
    } catch (error) {
      // Ignored
    } finally {
      commit(types.SET_CURRENT_PAGE_PAGINATION, { page: 0 });
      commit(types.LOGOUT);
    }
  },

  forceLogout({ commit }) {
    commit(types.SET_CURRENT_PAGE_PAGINATION, { page: 0 });
    commit(types.LOGOUT);
  },

  async getToken({ commit }) {
    try {
      const token = await axios.get('/api/web/auth/temporal-token');
    } catch (error) {
      throw error;
    }
  },

  async updateUserConnection({ commit }, params) {
    try {
      params.platform = "WEB";
      await axios.post('/api/web/auth/connection-status', params);
    } catch (error) {
      throw error;
    } finally {
      //commit(types.CONNECTION);
    }
  },

  async updateChatAlert({ commit }) {
    try {
      await axios.post('/api/web/auth/chat-alert');
    } catch (error) {
      throw error;
    } finally {
      //commit(types.CONNECTION);
    }
  },

  async userHasEnableTheChat({commit}, userId) {
    await axios.put(`/api/web/user/${userId}/enable-chat`);
  },
  async messageLimit({commit}, userId) {
    return await axios.get(`/api/web/user/${userId}/blocked-muted`);
  },
  async getControlPanelOptionStatus({commit}, option) {
    return await axios.get(`/api/web/control-panel/${option}`);
  }
};
